import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerIsPhoneCss = "chhqo1k";
const containerWithStrokeCss = "c1658x0z";
const containerCss = "csdqte0";
const Container = forwardRef((props, ref) => {
  const {
    withStroke,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone,
    [containerWithStrokeCss]: withStroke
  }, props.className)} />;
});
export const Footer = ({
  onConfirm,
  onCancel,
  hasSelected,
  ...props
}) => <Container {...props}>
    <Button decoration="secondary" onClick={onCancel}>
      {I18n.t('publisher.action.cancel')}
    </Button>
    <Button decoration="primary" onClick={onConfirm} disabled={!hasSelected}>
      {I18n.t('publisher.action.continue')}
    </Button>
  </Container>;

require("./footer.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");